// =============================================================================
//  KOMPONENTE: EditTeamModal
// =============================================================================
import React, { useState, useEffect } from 'react';
import { CLASSIFICATIONS } from '../constants/classificationConstants';

const EditTeamModal = ({ team, tournament, onClose, onSave }) => {
  const [name, setName] = useState('');
  const [classification, setClassification] = useState('');

  useEffect(() => {
    if (team) {
      setName(team.name);
      setClassification(team.classification);
    }
  }, [team]);

  // GEÄNDERT: Zusätzliche Prüfung, um den Absturz sicher zu verhindern.
  if (!team || !tournament) return null;
  
  const getClassificationLabel = (key) => CLASSIFICATIONS.find(c => c.key === key)?.label || key;
  // GEÄNDERT: Die Logik verwendet nun das korrekte Feld `teamClassifications` aus dem `tournament`-Objekt.
  const teamClassifications = tournament.teamClassifications || [];

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(team._id, { name, classification });
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2>Mannschaft bearbeiten</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Mannschaftsname</label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Mannschafts-Wertung</label>
            <select value={classification} onChange={e => setClassification(e.target.value)}>
              {teamClassifications.map(cKey => <option key={cKey} value={cKey}>{getClassificationLabel(cKey)}</option>)}
            </select>
          </div>
          <div className="form-buttons">
            <button type="submit">Speichern</button>
            <button type="button" className="btn-cancel" onClick={onClose}>Abbrechen</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTeamModal;